import amplifyStore from 'amplify-store';
import contextData from '../contextData';

/**
 * Module to get and set values from local storage. Please define all keys for access to the local
 * storage in the "keys" property to prevent the proliferation of *magic strings*.
 */
function LocalStorageHelper() {

  const self = this;

  self.keys = {
    languageCode: 'languageCode',
    authenticationRedirectHash: 'authenticationRedirectHash',
    authenticationRegistrationId: 'authenticationRegistrationId',
    requestsFilterCriteria: 'requestsFilterCriteria',
    requestsPage: 'requestsPage',
    camerasPage: 'camerasPage'
  };

  /**
   * Gets a value previously persisted. Uses the authenticated user's email address as part of the key.
   * @param {string} key
   * @return {*} Returns undefined if there isn't a value for the key
   */
  self.getSessionValue = function (key) {
    return amplifyStore.sessionStorage(key);
  };

  /**
   * Persists a value. Uses the authenticated user's email address as part of the key.
   * @param {string} key
   * @param {*} value Anything that can be serialized as JSON
   */
  self.setSessionValue = function (key, value) {
    amplifyStore.sessionStorage(key, value);
  };

  /**
   * Clears a persisted value. Uses the authenticated user's email address as part of the key.
   * @param {string} key
   */
  self.clearSessionValue = function (key) {
    amplifyStore.sessionStorage(key, null);
  };

  self.getAuthUserSessionValue = function (key) {
    const personalizedKey = getPersonalizedKey(key);
    return amplifyStore.sessionStorage(personalizedKey);
  };

  self.setAuthUserSessionValue = function (key, value) {
    const personalizedKey = getPersonalizedKey(key);
    amplifyStore.sessionStorage(personalizedKey, value);
  };

  self.clearAuthUserSessionValue = function (key) {
    const personalizedKey = getPersonalizedKey(key);
    amplifyStore.sessionStorage(personalizedKey, null);
  };

  function getPersonalizedKey(key) {
    if (!contextData.userData) {
      throw new Error('User data is not available');
    }
    const emailAddress = contextData.userData.emailAddress();
    const personalizedKey = `${key}-${emailAddress}`;
    return personalizedKey;
  }
}

export default new LocalStorageHelper();
